// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button[data-v-bff2f64a]{margin-right:12px}.text-big[data-v-bff2f64a]{font-size:24px}.text-big[data-v-bff2f64a],.text-small[data-v-bff2f64a]{text-align:center}", ""]);
// Exports
module.exports = exports;
